module.exports = __webpack_public_path__ + "img/estate.ab2a0e02.png";